import { render, staticRenderFns } from "./event_entry.vue?vue&type=template&id=2f184494&"
import script from "./event_entry.vue?vue&type=script&lang=js&"
export * from "./event_entry.vue?vue&type=script&lang=js&"
import style0 from "./event_entry.vue?vue&type=style&index=0&id=2f184494&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports